import { useCallback, useState } from "react";
import HOME_PHONE from "../../../../../constants/lib/homePhone";
import { HomePhoneProduct } from "../../../../../types/homePhone";

interface UseOrderReviewStateResult {
  hasPaymentCard: boolean;
  currency: string;
  onCardsLoaded: (hasCard: boolean) => void;
}

const useOrderReviewState = (
  product: HomePhoneProduct,
): UseOrderReviewStateResult => {
  const [hasPaymentCard, setHasPaymentCard] = useState(false);

  const onCardsLoaded = useCallback((hasCard: boolean) => {
    setHasPaymentCard(hasCard);
  }, []);

  const currency = product.currency || HOME_PHONE.FALLBACK_CURRENCY;

  return { hasPaymentCard, currency, onCardsLoaded };
};

export default useOrderReviewState;
